import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// O Leaflet mede o tamanho do container só na hora que o mapa é criado —
// se esse container mudar de tamanho depois (CSS, remontagem em outra
// posição da árvore, um modal de tela cheia) sem um resize de JANELA de
// verdade, os tiles ficam cortados/desalinhados até algo forçar um
// recálculo. Esse componente genérico força esse recálculo sempre que
// `gatilho` mudar — usado por qualquer mapa Leaflet que entra/sai de um
// modo "tela cheia" (DesenhoGeometriaMapa, MapaProducao).
export default function AjustaTamanhoMapa({ gatilho }: { gatilho: unknown }) {
  const map = useMap();
  useEffect(() => {
    const id = setTimeout(() => map.invalidateSize(), 0);
    return () => clearTimeout(id);
  }, [map, gatilho]);
  return null;
}
